import React, { useEffect, useState } from 'react';
import Loading from './Loading';
import '../styles/_vehiclesTable.scss';
import Popup from './Popup';

const MemberTable = ({ user, vehicles, loading, dataError, getMyVehicles }) => {
  const [loadingWait, setLoadingWait] = useState(false);
  const [showVehicle, setShowVehicle] = useState(false);
  const [vehicleLoading, setVehicleLoading] = useState(false);
  const [vehicleError, setVehicleError] = useState('');
  const [carData, setCarData] = useState({
    year: "",
    make: "",
    model: "",
    licensePlate: "",
    color: ""
  })

  useEffect(() => {
    // show loading animation for at least 2 seconds
    setTimeout(function () {
      setLoadingWait(true)
    }, 2000);
  }, [])

  useEffect(() => {
    if (!showVehicle) {
      // hiding membership popup, reset stages
      resetVehicle();
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, [showVehicle])

  // membership popup
  const onChangeVehicle = (e) => {
    setCarData({
      ...carData,
      [e.target.name]: e.target.value
    })
  }

  const onAddNewVehicle = async () => {
    if (!vehicleLoading) {
      setVehicleError('');
      setVehicleLoading(true);

      try {
        const rawResponse = await fetch(`/api/vehicles`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({vehicle: carData, userId: user.id})
        });

        const content = await rawResponse.json();
        if (content.error) {
          setVehicleError(content.error);
          setVehicleLoading(false);
        } else {
          getMyVehicles();
          resetVehicle();
          setShowVehicle(false);
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  const resetVehicle = () => {
    setVehicleError('');
    setVehicleLoading(false);
    setCarData({
      year: '',
      make: '',
      model: '',
      licensePlate: '',
      color: ''
    })
  }

  return (
    <>
      { !loading && dataError !== '' &&
        <p className="table-message">{ dataError }</p>
      }

      { dataError === '' && !loading && vehicles.length === 0 &&
        <>
          <p className="table-message">{'You have no vehicles :('}</p>
          <div className="btn primary" onClick={() => setShowVehicle(true)}>+ Add Vehicle</div>
        </>
      }

      { dataError === '' && (loading || vehicles.length > 0 ) && 
        <>
          <div className="vehicles-list">
            {vehicles && vehicles.map((result, index) => {
              return (
                <div key={`membershiplist--${index}`}>
                  <h3>Vehicle #{index + 1}</h3>
                  <div><b>Member Number:</b> {result.memberNumber}</div>
                  <div style={result.membership === 'Unassigned' ? {color: 'red'} : null}><b>Membership:</b> {result.membership}</div>
                  <div><b>Year:</b> {result.year}</div>
                  <div><b>Make:</b> {result.make}</div>
                  <div><b>Model:</b> {result.model}</div>
                  <div><b>Color:</b> {result.color}</div>
                  <div><b>License Plate:</b> {result.licensePlate}</div>
                </div>
              )
            })}
          </div>
          <div className="vehicles-table">
          { (loading || !loadingWait) &&
            <Loading></Loading>
          }
          <table>      
            <thead>
              <tr>
                <th>Member #</th>
                <th>Membership</th>
                <th>Year</th>
                <th>Make</th>
                <th>Model</th>
                <th>Color</th>
                <th>Plate</th>
              </tr>
            </thead>
            <tbody>
              {vehicles && vehicles.map((result, index) => {
                return (
                  <tr key={'membership--' + index} className={`${index % 2 === 1 ? 'highlight' : ''}`}>
                    <td>{result.memberNumber}</td>
                    <td className={result.membership === 'Unassigned' ? 'expired' : ''}>{result.membership}</td>
                    <td>{result.year}</td>
                    <td>{result.make}</td>
                    <td>{result.model}</td>
                    <td>{result.color}</td>
                    <td>{result.licensePlate}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
        <div className="btn primary" onClick={() => setShowVehicle(true)}>+ Add Vehicle</div>
        </>
      }

      <Popup
        showPopup={showVehicle}
        loading={vehicleLoading}
        setShowPopup={setShowVehicle}
        user={user}
        title={'Add Vehicle Membership'}
        buttonTitle={'Add'}
        buttonAction={onAddNewVehicle}
        error={vehicleError}
      >
        <>
          <p className="popup-description">Each vehicle needs its own Quik Quality membership. Please fill in all the fields below.</p>
          <input type="text" placeholder="year" name="year" value={carData.year} onChange={(e) => onChangeVehicle(e)} className={carData.year === '' && (vehicleError !== '') ? 'error' : ''}/>
          <input type="text" placeholder="make" name="make" value={carData.make} onChange={(e) => onChangeVehicle(e)} className={carData.make === '' && (vehicleError !== '') ? 'error' : ''}/>
          <input type="text" placeholder="model" name="model" value={carData.model} onChange={(e) => onChangeVehicle(e)} className={carData.model === '' && (vehicleError !== '') ? 'error' : ''} />
          <input type="text" placeholder="license plate" name="licensePlate" value={carData.licensePlate} onChange={(e) => onChangeVehicle(e)} className={carData.licensePlate === '' && (vehicleError !== '') ? 'error' : ''}/>
          <input type="text" placeholder="color" name="color" value={carData.color} onChange={(e) => onChangeVehicle(e)} className={carData.color === '' && (vehicleError !== '') ? 'error' : ''}/>
        </>
        {/* {makePayment &&
          <Fragment>
            <p className="popup-description">In order to complete this process, please pay for your membership.</p>
            <img src="./paypal-logo.png" alt="paypal" style={{ height: '100px', marginBottom: '2rem' }}/>
            <input type="text" placeholder="PayPal Username" name="ppUsername" value={carData.ppUsername} onChange={(e) => onChangeMembership(e)} className={carData.ppUsername === '' && (membershipError !== '') ? 'error' : ''} />
            <input type="password" placeholder="PayPal Password" name="ppPassword" value={carData.ppPassword} onChange={(e) => onChangeMembership(e)} className={carData.ppPassword === '' && (membershipError !== '') ? 'error' : ''}/>
          </Fragment>
        } */}
      </Popup>
    </>
  )
}

export default MemberTable;